import { Button } from "@mui/material";

export default function ButtonEdit({...props}) {
  return <Button sx={{textTransform: "initial", fontSize:"0.7rem", textDecoration: "underline"}} {...props} color="blueOcean">Editar</Button>;
}
